import { FeatureFlags } from './featureFlags';

export enum SubApp {
  RESOURCES = 'Resources UI',
  RECRUITMENT = 'Recruitment Admin',
  ADMIN = 'Admin Portal',
  CHAT = 'Whatsapp Chat',
  HOUR_REPORTING = 'Hour Reporting',
  QUESTIONS = 'Question Management',
  RECRUITMENT_REPORTING = 'Recruitment Reporting',
  AI_OBSERVABILITY = 'AI Observability',
  WORKER_CHAT = 'Test worker chat',
}

export type SubAppAccessRequirement = 'AI_OBSERVABILITY' | 'WORKER_CHAT' | 'CHAT_DASHBOARD';

export interface MenuItem {
  id: string;
  label: string;
  path: string;
}

export interface SubAppConfig {
  id: SubApp;
  label: string;
  icon?: React.ReactNode;
  menuItems: MenuItem[];
  component: React.ComponentType;
  /** When set, the sidebar entry is only shown while this feature flag is on. */
  featureFlag?: keyof FeatureFlags;
  /** Optional authorization policy used by the shell to hide restricted entries. */
  requiredAccess?: SubAppAccessRequirement;
  /** Any one of these Keycloak realm/client roles is required to show the entry. */
  requiredRoles?: string[];
}
